// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"541ce0c3","377":"a68b7a34","417":"328f1675","467":"746ef016","626":"e5e40771","870":"bbae1a93"}[chunkId] + ".js";
};